module.exports = __webpack_public_path__ + "img/voucher_desktop_failed.e9aa3c80.svg";